import {Component, Input} from '@angular/core';
import {Contenitore} from "../../../_models/Contenitore";
import {ContenitoriCreateComponent} from "../../movimenti/contenitori-create/contenitori-create.component";
import {MovimentiService} from "../../../_services/movimenti.service";
import {OrganizzazioniService} from "../../../_services/organizzazioni.service";
import {ModalController} from "@ionic/angular";
import {SaveMessage} from "../../../_helpers/save-message";
import {constants} from "../../../_helpers/constants";
import {LicenzeService} from "../../../_services/licenze.service";

@Component({
  selector: 'app-contenitore-label',
  templateUrl: './contenitore-label.component.html',
  styleUrls: ['./contenitore-label.component.scss'],
})
export class ContenitoreLabelComponent {
  @Input() codBox = '';
  protected readonly constants = constants;

  constructor(
    public licenseService: LicenzeService,
    private modalCtrl: ModalController,
    private saveMessage: SaveMessage,
    private organizzazioniService: OrganizzazioniService,
    private movimentiService: MovimentiService) { }

  async openContenitore(codBox: string) {
    this.movimentiService.getContenitoreAsync(
      this.organizzazioniService.organizzazioneId, codBox)
      .then(async (contenitore: Contenitore) => {
        const modal = await this.modalCtrl.create({
          component: ContenitoriCreateComponent,
          componentProps: {contenitore: contenitore, isNew: contenitore == null},
          backdropDismiss: false,
          cssClass: 'custom-modal'
        });
        await modal.present();
        const {role} = await modal.onWillDismiss();
        if (role === 'confirm') {
        }
      })
      .catch(() => this.saveMessage.messageError("Ci sono problemi con il caricamento del contenitore."));
  }

  async copyCodBox(codBox: string) {
    try {
      await navigator.clipboard?.writeText(codBox);
      this.saveMessage.messageInfo("Codice contenitore copiato.");
    } catch {
      this.saveMessage.messageError("Impossibile copiare il codice contenitore.");
    }
  }
}
